import { render } from "./QuestionPanel.vue?vue&type=template&id=b052ffb6"
import script from "./QuestionPanel.vue?vue&type=script&lang=ts"
export * from "./QuestionPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script